module.exports = __webpack_public_path__ + "static/media/timer-session.7ef0008e.svg";